import styled, { css } from 'styled-components';
import { defaultTheme } from '@styles/theme.styled';
import { generateScales, generateScalingQueries } from '@helpers/generate-media-queries';
import { createTextLinkCSS } from '@components/link/link.styled';

export const StyledDescription = styled.div<{
  $fontColor: keyof typeof defaultTheme.colors;
  $fontSize: keyof typeof defaultTheme.fontSize;
  $margin: keyof typeof defaultTheme.spacing | undefined;
}>`
  ${({ theme, $fontSize, $fontColor = 'dark', $margin }) => {
    const bottomMargin: string = $margin ? theme.spacing[$margin] : '0';

    return css`
      font-family: ${theme.fontFamily.text};
      line-height: ${theme.lineHeights.lg};
      color: ${theme.colors[$fontColor]};
      margin-bottom: ${bottomMargin};
      ${generateScalingQueries('margin-bottom', bottomMargin, theme)}

      ${generateScales(
        'font-size',
        theme.fontSize[$fontSize].mobile,
        theme.fontSize[$fontSize].desktop,
        theme
      )}

      p + p, p + ul, ul + p, h6 + p, h5 + p, h6 + ul, h5 + ul, ul + h6, ul + h5 {
        ${generateScales(
          'margin-top',
          theme.fontSize[$fontSize].mobile,
          theme.fontSize[$fontSize].desktop,
          theme
        )}
      }

      p + h6,
      p + h5 {
        margin-top: 2rem;
      }

      p.block-img img {
        width: 100%;
        height: auto;
        object-fit: cover;
        object-position: 50% 50%;
        border-radius: ${theme.borderRadius.small};
      }

      strong {
        font-weight: ${theme.fontWeights.bold};
      }

      ul {
        list-style-type: square;
        list-style-color: ${theme.colors.primary};
        margin-left: 2rem;
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;

        li + li {
          margin-top: 1rem;
        }

        li::marker {
          color: ${theme.colors.primary};
        }
      }

      h6,
      h5 {
        font-family: ${theme.fontFamily.display};
        font-weight: ${theme.fontWeights.bold};
        line-height: ${theme.lineHeights.sm};
        color: ${theme.colors.black};
      }

      h5 {
        font-size: 1.5rem;

        @media only screen and (max-width: ${theme.breakpoints.lg}) {
          font-size: 1.375rem;
        }

        @media only screen and (max-width: ${theme.breakpoints.sm}) {
          font-size: 1.25rem;
        }
      }

      h6 {
        font-size: 1.25rem;

        @media only screen and (max-width: ${theme.breakpoints.md}) {
          font-size: 1.125rem;
        }
      }

      a {
        ${() => createTextLinkCSS(theme)}
        font-family: inherit;
        font-weight: normal;
        background-position: 50% 95%;
        background-size: 100% 0.125rem;

        :hover,
        :focus {
          background-size: 0% 0.125rem;
        }

        &::after {
          display: none;
        }
      }
    `;
  }}
`;
